export default __webpack_public_path__ + "static/media/senior-sample6.dcee7963.png";